import { render, staticRenderFns } from "./ResubmitAttachments.vue?vue&type=template&id=754e66a4&scoped=true"
import script from "./ResubmitAttachments.vue?vue&type=script&lang=ts"
export * from "./ResubmitAttachments.vue?vue&type=script&lang=ts"
import style0 from "./ResubmitAttachments.vue?vue&type=style&index=0&id=754e66a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e66a4",
  null
  
)

export default component.exports